import { useChatContext } from '../../contexts/ChatContext'

export default function ChatToggle() {
  const { toggleChat, isOpen, unreadCount, hasUnread, shouldPulse } = useChatContext()

  return (
    <button
      onClick={toggleChat}
      className={`
        fixed bottom-6 right-6 z-50
        w-14 h-14 rounded-full
        flex items-center justify-center
        shadow-lg transition-all duration-200
        ${isOpen
          ? 'bg-gray-600 hover:bg-gray-700'
          : hasUnread
            ? `bg-red-500 hover:bg-red-600 ${shouldPulse ? 'animate-pulse' : ''}`
            : 'bg-primary hover:bg-purple-800'
        }
      `}
      aria-label={isOpen ? 'Close chat' : `Open chat${hasUnread ? ` (${unreadCount} unread)` : ''}`}
    >
      {isOpen ? (
        // X icon when open
        <svg
          className="w-6 h-6 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      ) : (
        // Chat bubble icon when closed
        <svg
          className="w-6 h-6 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
          />
        </svg>
      )}

      {/* Unread badge with count */}
      {!isOpen && unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-white text-red-500 text-xs font-bold rounded-full min-w-5 h-5 px-1 flex items-center justify-center border-2 border-red-500">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  )
}

